import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { BITRIX_STORE } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import type { LowStockItem } from '@tailorcast/shared-types';

export function useLowStock(threshold: number = 5) {
  const { isBitrix24 } = useBitrix24();
  const { data: telegramStatus } = useTelegramStatus();

  return useQuery({
    queryKey: ['low-stock', threshold],
    queryFn: () =>
      api.get<{ items: LowStockItem[] }>(`${BITRIX_STORE.LOW_STOCK}?threshold=${threshold}`),
    enabled: isBitrix24 && telegramStatus?.linked === true,
    staleTime: 5 * 60_000,
  });
}
